import { META } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#0A0A0A] text-[#F8F4ED] mt-24 border-t border-[#F8F4ED]/15">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-14 grid md:grid-cols-[1.6fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif italic text-5xl">{META.brand}</p>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#A33A3A] mt-2">— Photographer · Issue magazine</p>
          <p className="font-sans text-sm text-[#F8F4ED]/55 mt-5 leading-[1.7] max-w-md">A photographer's practice published as a quarterly magazine. Forty-eight plates a year. Editorial, wedding, travel. Studio in Brooklyn.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#A33A3A] mb-3">Issue 12</p>
          <ul className="space-y-2 font-serif text-sm"><li><button onClick={() => setPage('archive')} className="hover:text-[#A33A3A]">Archive · 47 plates</button></li><li><button onClick={() => setPage('note')} className="hover:text-[#A33A3A]">Editor's note</button></li><li><button onClick={() => setPage('commission')} className="hover:text-[#A33A3A]">Commission</button></li></ul>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#A33A3A] mb-3">Studio</p>
          <p className="font-sans text-sm text-[#F8F4ED]/85 leading-[1.65]">68 Jay Street, 412<br />Brooklyn, NY 11201<br />By appointment</p>
        </div>
      </div>
      <div className="border-t border-[#F8F4ED]/15 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#F8F4ED]/40"><span>© 2026 {META.brand} · Issue 12 · Brooklyn</span><span>studio@mirahalcyon.co</span></div>
    </footer>
  );
}
